export default __webpack_public_path__ + "static/media/instoremusic3.ce249a56.jpg";